import Vue from 'vue';
import App from './App.vue';
import * as PhilaUI from "@phila/phila-ui";
import router from "./router";
import VueI18n from 'vue-i18n';

import en from './i18n/en-us';
import ar from './i18n/ar-ar';
import es from './i18n/es-us';
import zh from './i18n/zh-cn';
import ht from './i18n/ht-ht';
import pt from './i18n/pt-pt';
import sw from './i18n/sw-sw';
import vi from './i18n/vi-vn';
import ru from './i18n/ru-ru';
import fr from './i18n/fr-fr';

// import i18n from './i18n/i18n';
// console.log('i18n:', i18n);

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en-US",
  messages: {
    'en-US': en,
    ar: ar,
    es: es,
    zh: zh,
    ht: ht,
    pt: pt,
    sw: sw,
    vi: vi,
    ru: ru,
    fr: fr,
  },
});

Vue.use(PhilaUI);
Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
  template: '<div><lang-selector /><app /></div>',
}).$mount('#app');